module.exports = __webpack_public_path__ + "img/cvaenergie-logo.7cc99dd3.svg";